define('views/content/reseller_application',['require','views/base/item_page_view','jquery-validation','select2','text!templates/content/reseller_application.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('jquery-validation');
    require('select2');

    var temp = require("text!templates/content/reseller_application.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'company_name': "required",
                    'phone_number': "required",
                    'company_email': "required",
                    'website': "required",
                    'contact_name': "required",
                    'contact_phone_number': "required",
                    'contact_email': "required",
                    'city_country': "required",
                    'address': "required"
                },
                messages: {
                    'company_name': App.polyglot.t('company_name_required'),
                    'phone_number': App.polyglot.t('phone_number_required'),
                    'company_email': App.polyglot.t('company_email_required'),
                    'website': App.polyglot.t('website_required'),
                    'contact_name': App.polyglot.t('name_surname_required'),
                    'contact_phone_number': App.polyglot.t('gsm_required'),
                    'contact_email': App.polyglot.t('email_required'),
                    'city_country': App.polyglot.t('city_country_required'),
                    'address': App.polyglot.t('address_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {
                if (this.beforeSubmit) {
                    if (!this.beforeSubmit()) {
                        return false;
                    }
                }

                this.ui.submitButton.addClass('loading');
                var isCreate = _this.model.get('id') === null;

                grecaptcha.ready(function() {
                    grecaptcha.execute(App.Config.recaptchaKey, {action: 'submit'}).then(function(token) {
                    
                     
                        _this.model.save({recaptchaToken: token}, {
                            success: function (model, response, options) {
                                _this.ui.submitButton.removeClass('loading');

                                // Reload if created new reseller
                                if (_this.afterSuccess) {
                                    _this.afterSuccess(response);
                                } else {
                                    if (isCreate) {
                                        App.context.redirect('/' + _this.basePath + '/' + model.get('id'));

                                        App.utils.showMessage('success', App.polyglot.t('create_success'));
                                    } else {
                                        App.utils.showMessage('success', App.polyglot.t('update_success'));
                                    }
                                }
                            },
                            error: function (model, response, options) {
                                _this.ui.submitButton.removeClass('loading');

                                // Show error messages
                                if (response.responseJSON.errors) {
                                    for (var i=0; i<response.responseJSON.errors.length; i++) {
                                        App.utils.showMessage('error', response.responseJSON.errors[i].message);
                                    }
                                }
                            }
                        });
                    });
                  });

          

            }
        },

        afterSuccess: function () {
            App.utils.showMessage('success', App.polyglot.t('reseller_application_success'));
            App.context.redirect('/');
        }
    });
});

